import { ConfigType } from "../../abstract/Form";
import { EthnicityType } from "../../types";
import { enumToOptions } from "../../utils";

export const config: ConfigType = {
  right: [
    {
      label: "form.patientBackground",
      rows: [
        {
          fields: [
            {
              name: "patient",
              label: "fields.name",
              type: "text",
              required: true,
            },
          ],
        },
        {
          fields: [
            {
              name: "birth",
              label: "fields.birth",
              type: "month",
              required: true,
            },
          ],
        },
        {
          fields: [
            {
              name: "height",
              label: "fields.height",
              type: "height",
              required: true,
            },
            {
              name: "weight",
              label: "fields.weight",
              type: "weight",
              required: true,
            },
          ],
        },
        {
          fields: [
            {
              name: "ethnicity",
              label: "fields.ethnicity",
              type: "tag-select",
              required: true,
              placeholder: "form.placeholders.ethnicity",
              caption: "form.captions.ethnicity",
              options: enumToOptions(EthnicityType),
            },
          ],
        },
      ],
    },
    {
      label: "form.cycleDetails",
      rows: [
        {
          fields: [
            {
              name: "history",
              label: "fields.history",
              type: "text",
              required: false,
              multiline: true,
            },
          ],
        },
        {
          fields: [
            {
              name: "sample",
              label: "fields.sample",
              type: "text",
              required: false,
              multiline: true,
            },
          ],
        },
        {
          fields: [
            {
              name: "tech",
              label: "fields.tech",
              type: "text",
              required: false,
              multiline: true,
            },
          ],
        },
      ],
    },
  ],
  left: [],
};
